import { TimePicker as EJ2TimePicker } from '@syncfusion/ej2-calendars';
import { Base } from './base-module';
/**
 * The `TimePicker` module is used configure the properties of Time picker type editor.
 */
export class TimePicker {
    constructor(parent) {
        this.compObj = undefined;
        this.parent = parent;
        this.parent.timeModule = this;
        this.base = new Base(this.parent, this);
    }
    render(e) {
        this.compObj = new EJ2TimePicker(this.parent.model);
        this.compObj.appendTo(e.target);
    }
    focus() {
        this.compObj.focusIn();
    }
    updateValue(e) {
        if (this.compObj && e.type === 'Time') {
            this.parent.setProperties({ value: this.compObj.value }, true);
            this.parent.extendModelValue(this.compObj.value);
        }
    }
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} - returns the string
     */
    getModuleName() {
        return 'time-picker';
    }
    /**
     * Destroys the module.
     *
     * @function destroy
     * @returns {void}
     * @hidden
     */
    destroy() {
        this.base.destroy();
    }
}
